document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".slushie-faq-item");

  faqItems.forEach(function (item) {
    const question = item.querySelector("h3");
    const answer = item.querySelector("p");

    if (!question || !answer) return;

    const button = document.createElement("button");
    button.type = "button";
    button.className = "slushie-faq-question";
    button.setAttribute("aria-expanded", "false");

    button.innerHTML =
      "<span>" +
      question.textContent +
      '</span><span class="slushie-faq-icon" aria-hidden="true">+</span>';

    answer.classList.add("slushie-faq-answer");
    answer.hidden = true;

    question.replaceWith(button);

    button.addEventListener("click", function () {
      const isOpen = button.getAttribute("aria-expanded") === "true";
      const icon = button.querySelector(".slushie-faq-icon");

      button.setAttribute("aria-expanded", String(!isOpen));
      answer.hidden = isOpen;

      if (icon) {
        icon.textContent = isOpen ? "+" : "−";
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function syncSlushieImageHeight() {
    const sections = document.querySelectorAll(".slushie-image-container");

    sections.forEach(function (section) {
      const content = section.querySelector(".slushie-image-content");
      const image = section.querySelector(".slushie-image-box img");

      if (!content || !image) return;

      if (window.innerWidth <= 749) {
        image.style.height = "";
        return;
      }

      const contentHeight = content.offsetHeight;
      image.style.height = contentHeight + "px";
    });
  }

  syncSlushieImageHeight();

  window.addEventListener("resize", syncSlushieImageHeight);

  window.addEventListener("load", syncSlushieImageHeight);
});

document.addEventListener("DOMContentLoaded", function () {
  const ctaSource = document.querySelector(".collection-banner-cta-source");

  if (!ctaSource) return;

  const possibleBannerTargets = [
    ".collection-hero__text-wrapper",
    ".collection-hero__title",
    ".collection-hero",
    ".page-width .section-header",
    ".section-header"
  ];

  let target = null;

  for (const selector of possibleBannerTargets) {
    const element = document.querySelector(selector);

    if (element) {
      target = element;
      break;
    }
  }

  if (!target) return;

  ctaSource.classList.add("collection-banner-cta");

  const title = target.querySelector("h1, .collection-hero__title");

  if (title && title.parentElement) {
    title.insertAdjacentElement("afterend", ctaSource);
  } else {
    target.appendChild(ctaSource);
  }
});